import React from "react";

import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { IoCheckmark, IoFlameOutline, IoCalendarOutline } from "react-icons/io5";

import { PALETTE } from "../../common/ThemeConstants";
import { parseDate } from "../../common/Utilities";
import { useSmartName } from "../../api/useSmartName";

export default function CardCompletedWorkout({
  planDay,
  isActive,
  height = 90,
}) {
  const parseName = useSmartName();
  const name = parseName(planDay.workout.name, 20, 50);

  return (
    <Card
      className={`my-2`}
      style={{
        border: "solid 0px",
        backgroundColor: PALETTE.WHITE,
        borderRadius: "20px",
        opacity: isActive ? 1 : 0.5,
      }}
    >
      <Row className="g-0 align-items-center" style={{ width: "100%" }}>
        <Col xs={3} className="align-self-center text-start p-1">
          <Card.Img
            style={{
              objectFit: "cover",
              height: height,
              width: height,
              borderRadius: "20px",
            }}
            src={planDay.workout.cover}
            alt={planDay.workout.name}
          />
        </Col>
        <Col xs={7} className="text-start" style={{ paddingLeft: "4px" }}>
          <p className="cardDescription mb-2" style={{ fontWeight: "bold" }}>
            {name}
          </p>
          <span
            className="cardDescription px-2 py-1 rounded-md"
            style={{
              color: PALETTE.DARKGRAY,
              background: PALETTE.LIGHTGRAY
            }}>
            <IoCalendarOutline size={14} style={{ marginBottom: 3, marginRight: 2 }} />
            {parseDate(planDay.date)}{" "}
          </span>
          <span
            className="cardDescription ms-1 px-2 py-1 rounded-md"
            style={{
              background: PALETTE.GRADIENTLIGHT,
              fontSize: "0.8rem",
              fontWeight: "500",
              color: PALETTE.DARKGRAY
            }}
          >
            <IoFlameOutline size={14} style={{ marginBottom: 2, marginRight: 2 }} />
            Fatica: <span style={{ fontWeight: "bold" }}>{planDay.fatigueLevel}</span>
          </span>
        </Col>
        <Col xs={2} className="align-self-center text-end px-3" style={{ height: "100%" }}>
          <IoCheckmark
            size={22}
            color={PALETTE.TRUEGRAY}
          />
        </Col>
      </Row>
    </Card>
  );
}
